export var StatusFacebookPopupConnectionEnum;
(function (StatusFacebookPopupConnectionEnum) {
    StatusFacebookPopupConnectionEnum["SUCCESS"] = "Success";
    StatusFacebookPopupConnectionEnum["TIME_OUT"] = "Timeout";
})(StatusFacebookPopupConnectionEnum || (StatusFacebookPopupConnectionEnum = {}));
